<template>
    <div class="get-styled-container page-container">

        <OutfitSwipeContainer
            ref="outfitSwipe"
            @swap-product="setSwapProduct"
        />

        <shop-items
            :outfitCurrent="outfitCurrent"
            :showShopItems="showShopItems"
            @swap-product="setSwapProduct"
        />

        <transition name="fade">
            <swap-item :product="swapProduct" v-if="showSwapProduct"></swap-item>
        </transition>

    </div>
</template>


<script>
    import OutfitSwipeContainer from "./outfit-swipe-container.vue";
    import ShopItems from "./shop-items.vue";
    import SwapItem from "./swap-item.vue";

    import {mapGetters} from "vuex";

    import {FILTER_TYPE_STYLE, RETURN_PAGE_GET_STYLED} from "../../config.js";

    export default {
        data() {
            return {
                showShopItems: false,
                showSwapProduct: false,
                swapProduct: null,
            };
        },
        components: {
            OutfitSwipeContainer,
            ShopItems,
            SwapItem,
        },
        computed: {
            ...mapGetters({
                outfitCurrent: "generatedOutfits/generatedOutfitCurrent",
            })
        },
        created(){
            this.$store.commit('menu/setReturnPage', RETURN_PAGE_GET_STYLED);
            this.$on("saveOutfit", () => {
                this.saveOutfit();
            });

            this.$on("shopItems", () =>{
                this.shopItems();
            });

            this.$on('closeSwapModal', () => {
                this.showSwapProduct = false;
            });
        },
        methods: {
            saveOutfit() {
                // Close the shop items section if open
                if (this.showShopItems) {
                    this.shopItems();
                }

                // Save the outfit
                this.$refs.outfitSwipe.saveNoAnimate();
            },
            setHeaderStyle(value) {
                this.$store.commit({
                    type: "menu/headerStyle",
                    headerStyle: value
                });
            },
            shopItems() {
                if (this.outfitCurrent?.products) {
                    this.showShopItems = !this.showShopItems;
                }
            },
            setSwapProduct(product){
                this.showSwapProduct = true;
                this.swapProduct = product;

                this.$helpers.trackEvent("swap_init", {content_id: product.product_id});
            },
        },
        mounted() {
            /* Generate outfit if one is not currently available */
            if (!this.outfitCurrent || !this.outfitCurrent.products) {
                this.$store.dispatch({
                    type: "generatedOutfits/generateNewOutfit"
                });
            }
        }
    };
</script>
